module.exports = __webpack_public_path__ + "static/media/phone-icon-bg--red.8b40b646.svg";